
import { Vue, Component, Prop } from 'vue-property-decorator';
import { UnscheduledPickups } from '@/features/schedule-pickup/types';
import { getPackageDetails } from '@/features/common/helpers';
import { modifyOrReturnShipment } from '@/features/shipment/helpers/createShipment';
import AddressDetails from './AddressDetails.vue';

@Component({
  components: {
    AddressDetails,
  },
})
export default class PickupItemDetails extends Vue {
  @Prop({ required: false, default: false }) show!: boolean;

  @Prop({ required: true }) pickup!: UnscheduledPickups;

  private getPackageDetails = getPackageDetails;

  private editShipment = (pickup: UnscheduledPickups) => {
    modifyOrReturnShipment(
      pickup.trackingNumber,
      'modify',
    );
  }
}
